<template lang="pug">
#empresa-tabela-inserir-contrato-originacao
    el-table(
        :data='contratosNaoEnviados',
        v-loading='carregando',
        @sort-change='ordenarContratos',
        @selection-change='handleSelectionChange',
        style='width: 100%'
    )
        el-table-column(type='expand', width='25', align='center')
            template(slot-scope='scope')
                el-descriptions
                    el-descriptions-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.regional")'
                    )
                        p {{ scope.row.regional }}

                el-descriptions
                    el-descriptions-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.gerenteRegional")'
                    )
                        p {{ scope.row.gerenteRegionalNome }}

                el-descriptions
                    el-descriptions-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.gerenteComercial")'
                    )
                        p {{ scope.row.gerenteComercialNome }}

                el-descriptions
                    el-descriptions-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.gestorTerritorial")'
                    )
                        p {{ scope.row.gestorTerritorialNome }}
        el-table-column(
            type='selection',
            width='45',
            v-if='removendo',
            align='center'
        )
        el-table-column(
            v-if='this.isBunge',
            prop='numeroContrato',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.numeroContrato")',
            sortable='custom',
            width='150'
        )
        el-table-column(
            v-if='!this.isBunge',
            prop='numeroContrato',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.numeroContrato")',
            sortable='custom',
            width='150'
        )
            .template(slot-scope='scope')
                span {{ formatarNumeroContrato(scope.row.numeroContrato) }}

        el-table-column(
            prop='material',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.cultura")',
            sortable='custom',
            min-width='190'
        )
        el-table-column(
            prop='safraNome',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.safra")',
            width='110'
        )
        el-table-column(
            prop='volumeContratado',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.volumeContratado")',
            sortable='custom',
            width='180'
        )
            .template(slot-scope='scope')
                span {{ scope.row.volumeContratado + ' t' }}
        el-table-column(
            v-if='usuarioLogado.ambienteLogado !== ambientes.PARAGUAY',
            prop='dataContrato',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.dataContrato")',
            sortable='custom',
            width='160'
        )
        el-table-column(
            prop='subEmpresaNome',
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.fornecedor")',
            min-width='260'
        )
        el-table-column(
            prop='cnpjSubEmpresa',
            :label='$t(`mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.${this.ambiente === "PY" ? "ruc" : "fornecedorCnpj"}`)',
            width='180'
        )
        template(slot='empty')
            el-empty(
                :description='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.semDados")'
            )
</template>

<script>
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';
import { mapGetters } from 'vuex';
export default {
    name: 'EmpresaTabelaInserirContratoOriginacao',

    props: {
        contratosNaoEnviados: {
            type: Array,
            required: true
        },
        ambiente: {
            type: String,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        },
        removendo: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            contratosSelecionados: [],
            colunaOrdenacao: {
                numeroContrato: () => 'numero_contrato_valor',
                volumeContratado: () => 'volume_contratado',
                dataContrato: () => 'data_contrato',
                material: () => 'material'
            },
            ambientes: AmbientesEmpresas
        };
    },
    computed: {
        ...mapGetters(['usuarioLogado']),
        isBunge() {
            return this.usuarioLogado.isBunge;
        }
    },

    methods: {
        async handleSelectionChange(dadosContrato) {
            this.contratosSelecionados = dadosContrato;
            const idsContratosOriginacao = this.contratosSelecionados.map(
                contrato => contrato.id
            );

            this.emiteRemoverContratoLote(idsContratosOriginacao);
        },
        emiteRemoverContratoLote(idsContratosOriginacao) {
            this.$emit('contratosSelecionados', idsContratosOriginacao);
        },
        ordenarContratos({ order, prop }) {
            const ordem = order === 'ascending' ? 'asc' : 'desc';
            const coluna = this.colunaOrdenacao[prop]();
            this.$emit('ordenar', `${coluna},${ordem}`);
        },
        formatarNumeroContrato(numeroContrato) {
            if (this.usuarioLogado.nameGroup === 'VITERRA') {
                const contratoStr = String(numeroContrato)
                    .replace(/\D/g, '')
                    .padStart(10, '0');
                const parte1 = contratoStr.slice(0, 7);
                const parte2 = contratoStr.slice(7);
                return `${parte1}-${parte2}`;
            }
            return numeroContrato;
        }
    }
};
</script>

<style lang="scss">
#empresa-tabela-inserir-contrato-originacao {
    td.el-table__cell.el-table__expanded-cell {
        margin: 0 16px;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        width: 960px;

        .el-descriptions-item__container {
            display: flex;
            flex-direction: column;
            width: fit-content;

            span.el-descriptions-item__label {
                font-weight: bold;
                font-size: 13px;
                color: var(--primary);
            }

            span.el-descriptions-item__content {
                font-size: 12px;
                width: 230px;
            }
        }
    }
    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;
        thead.has-gutter {
            height: 67px;
            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }
    }
    .el-table__cell {
        font-size: 12px;
    }
    .is-leaf {
        font-size: 13px;
    }

    .el-table .cell {
        word-break: normal;
    }
}
</style>
